import { useSelect, useDispatch } from '@wordpress/data';
import { __, sprintf }           from '@wordpress/i18n';
import { STORE_NAME }            from '../../../store';
import { ORDER_OPTIONS }         from '../../../store/constants';

export default function ActiveFiltersList( { showClearAll = true } ) {
	const filters         = useSelect( ( s ) => s( STORE_NAME ).getFilters(), [] );
	const hasActive       = useSelect( ( s ) => s( STORE_NAME ).hasActiveFilters(), [] );
	const categoryNames   = useSelect( ( s ) => s( STORE_NAME ).getCategoryNames(), [] );
	const {
		setSearch, setCategories, setTags,
		setMinPrice, setMaxPrice, setOrderby, resetFilters,
	} = useDispatch( STORE_NAME );

	if ( ! hasActive ) return null;

	const tags = [];

	if ( filters.search ) {
		tags.push( {
			key:   'search',
			label: sprintf( __( 'Search: "%s"', 'mwsb' ), filters.search ),
			clear: () => setSearch( '' ),
		} );
	}

	filters.categories.forEach( ( slug ) => {
		tags.push( {
			key:   `cat-${ slug }`,
			label: sprintf( __( 'Category: %s', 'mwsb' ), categoryNames[ slug ] || slug ),
			clear: () => setCategories( filters.categories.filter( ( c ) => c !== slug ) ),
		} );
	} );

	filters.tags.forEach( ( slug ) => {
		tags.push( {
			key:   `tag-${ slug }`,
			label: sprintf( __( 'Tag: %s', 'mwsb' ), slug ),
			clear: () => setTags( filters.tags.filter( ( t ) => t !== slug ) ),
		} );
	} );

	if ( filters.minPrice ) {
		tags.push( {
			key:   'min-price',
			label: sprintf( __( 'Min: %1$s%2$s', 'mwsb' ), window.mwsbData?.currency, filters.minPrice ),
			clear: () => setMinPrice( '' ),
		} );
	}

	if ( filters.maxPrice ) {
		tags.push( {
			key:   'max-price',
			label: sprintf( __( 'Max: %1$s%2$s', 'mwsb' ), window.mwsbData?.currency, filters.maxPrice ),
			clear: () => setMaxPrice( '' ),
		} );
	}

	if ( filters.orderby && filters.orderby !== 'menu_order' ) {
		const label = ORDER_OPTIONS.find( ( o ) => o.value === filters.orderby )?.label || filters.orderby;
		tags.push( {
			key:   'orderby',
			label: sprintf( __( 'Sort: %s', 'mwsb' ), label ),
			clear: () => setOrderby( 'menu_order' ),
		} );
	}

	return (
		<div className="mwsb-active-filters">
			{ tags.map( ( tag ) => (
				<span key={ tag.key } className="mwsb-active-filter-tag">
					{ tag.label }
					<button
						className="mwsb-active-filter-tag__remove"
						onClick={ tag.clear }
						aria-label={ sprintf( __( 'Remove filter: %s', 'mwsb' ), tag.label ) }
					>
						&times;
					</button>
				</span>
			) ) }

			{ showClearAll && tags.length > 1 && (
				<button className="mwsb-btn mwsb-btn--clear-all" onClick={ resetFilters }>
					{ __( 'Clear All', 'mwsb' ) }
				</button>
			) }
		</div>
	);
}
